export default {
    CREATE_ATTRIBUTE: "Создать атрибут"
};
